import { minimalInputTheme } from '@/app/theme';
import { emailSchema } from '@/utils/validation';
import * as Yup from 'yup';

export const inputProps = {
	...minimalInputTheme,
	'& .MuiInput-underline:before': {
		borderBottom: 'none',
	},
	'& .MuiInputBase-input': {
		color: 'inherit',
		fontWeight: 'inherit',
		padding: '0 0 5px',
	},
};

export const clientHeaders = {
	name: 'Client',
	tradingAs: 'Trading as',
	website: 'Website address',
	industry: 'Industry',
	numberOfEmployees: 'No. of employees',
	annualRevenue: 'Annual turnover',
	address: 'Address',
	description: 'Description of business activities',
	sourceOfBusiness: 'Source of business',
	isCurrent: 'Current state',
	referralPartner: 'Referral partner email',
};

export const addressSubtitles = {
	address: 'Street address',
	city: 'City',
	Suburb: 'Suburb',
	StateName: 'StateName',
	country: 'Country',
	Postcode: 'Postcode',
};

export const contactHeaders = {
	Name: 'Full name',
	Email: 'Email',
	Telephone: 'Phone number',
	Telephone2: 'Alternative number',
	BirthDate: 'Date of birth',
	JobTitle: 'Role',
	IsPrimary: 'Main contact',
};
const telephoneSchema = Yup.string()
	.required('Phone number is required.')
	.min(7, 'Phone number should be more than 7 characters')
	.max(15, 'Phone number should be no more than 15 characters');
export const schemaFields = {
	name: Yup.string().required('Name is required.'),
	Name: Yup.string().required('Name is required.'),
	firstname: Yup.string().required('First name is required.'),
	lastname: Yup.string().required('Last name is required.'),

	phone: telephoneSchema,
	Telephone: telephoneSchema,
	dateOfBirth: Yup.date()
		.nullable(true)
		.test('is-valid-date', 'Date of birth cannot be in the future', (value) => {
			if (!value) return true; // Allow null/empty
			return value <= new Date();
		}),
	email: emailSchema(),
	Email: emailSchema(),
};

// Dynamically create Yup validation schema based on array of headers
export const createValidationSchema = (headers, options = {}) => {
	const schema = headers.reduce((acc, header) => {
		if (Object.keys(schemaFields).includes(header)) {
			if (options.skipEmail && (header === 'email' || header === 'Email')) {
				return acc; // Skip email validation
			}
			acc[header] = schemaFields[header];
		}
		return acc;
	}, {});
	return Yup.object().shape(schema);
};
